import { Component } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { AuthService } from '../../services/auth/auth.service';
import { TranslateService } from '@ngx-translate/core';
import { Router } from '@angular/router';

type LoginForm = {
  email: FormControl<string>;
  password: FormControl<string>;
  language: FormControl<string>;
};

@Component({
  selector: 'app-home-page',
  templateUrl: './login-page.component.html',
  styleUrls: ['./login-page.component.scss']
})
export class LoginPageComponent {
  public loginForm: FormGroup<LoginForm> = this.generateForm();

  constructor(
    private translate: TranslateService,
    private router: Router,
    private auth: AuthService
  ) {}

  private generateForm(): FormGroup<LoginForm> {
    return new FormGroup({
      email: new FormControl('', { nonNullable: true, validators: [Validators.required, Validators.email] }),
      password: new FormControl('', { nonNullable: true, validators: [Validators.required] }),
      language: new FormControl(this.currentLanguage, { nonNullable: true })
    });
  }

  login(form: FormGroup<LoginForm>): void {
    const { email, password } = form.getRawValue();

    this.auth.login(email, password);
  }

  get currentLanguage(): string {
    return this.translate.currentLang || this.translate.defaultLang;
  }

  get availableLanguages(): string[] {
    return this.translate.getLangs();
  }

  public handlerChangeLanguage(event: Event): void {
    if (event.target instanceof HTMLSelectElement) {
      this.translate.use(event.target.value);
      localStorage.setItem('lang', event.target.value);
    }
  }


}
